import IntlService from 'ember-intl/services/intl';
import { closest } from 'volta/utils/dom-utils';
import { getOrElse } from 'volta/utils/object-utils';

import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface IArgs {
  editModeOnly?: boolean;
  disabled: boolean;
  canEndEditing?: boolean;
  onEditingStart?: () => void;
  onEditingEnd?: () => void;
  onSubmit?: () => void;
}

export default class BaseFormEditor extends Component<IArgs> {
  @service intl!: IntlService;

  @tracked isEditing: boolean = Boolean(getOrElse(this.args.editModeOnly, false));

  get canEndEditing() {
    return this.args.canEndEditing ?? true;
  }

  @action
  startEditing() {
    if (this.isEditing || this.args.disabled || this.args.editModeOnly) {
      return;
    }
    this.isEditing = true;
    this.args.onEditingStart?.();
  }

  @action
  endEditing(event: Event) {
    const closestDropdown = closest(event.target as HTMLElement, '.ember-basic-dropdown-content');

    if (
      closestDropdown ||
      !this.isEditing ||
      this.args.disabled ||
      this.args.editModeOnly ||
      !this.canEndEditing
    ) {
      return;
    }
    this.isEditing = false;
    this.args.onEditingEnd?.();
  }

  @action
  submit(event: Event) {
    if (this.args.disabled || this.args.editModeOnly) {
      return;
    }
    this.args.onSubmit?.();
    this.endEditing(event);
  }

  toggleEditing = (event: Event) => {
    if (this.args.disabled || this.args.editModeOnly) {
      return;
    }
    if (this.isEditing) {
      this.endEditing(event);
    } else {
      this.startEditing();
    }
  };
}
